const tooltipInitial = {
    show: false,
    context: { position: { x: 0, y: 0 } },
    loading: false
}

const initialState = {
    linkTooltip: { ...tooltipInitial },
    nodeTooltip: { ...tooltipInitial },
    contextMenu: { ...tooltipInitial },
    commonTooltip: { ...tooltipInitial },
}

export { tooltipInitial, initialState as tooltipInitialState }
